import { esusApi } from "@/services/api";

export type ResumeIndicatorB6Params = {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	ine?: string;
};

export class ResumeIndicatorB6Data {
	totalAtraumaticRestorativeTreatmentProcedures: number = 0;
	totalProcedures: number = 0;
}

export async function getResumeIndicatorB6({ uf, ibgeCode, ...params }: ResumeIndicatorB6Params) {
	const response = await esusApi.get<ResumeIndicatorB6Data>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esb/b6/resume`,
		params
	);
	return response.data || new ResumeIndicatorB6Data();
}
